export default __webpack_public_path__ + "static/univers-rounded-light-42c67c6649c7b21d0126def2295e6315.woff";